import React, { useEffect, lazy, Suspense, useState } from 'react';
// action
import { checkAutoLogin } from './services/AuthService';
import { isAuthenticated } from './store/selectors/AuthSelectors';

import Index from './views/index'
import { connect, useDispatch } from 'react-redux';
import {  Route, Routes, useLocation , useNavigate , useParams } from 'react-router-dom';

// import Login from './views/Login/Login';
import Signup from './views/Signup/Signup';
import Dashboard from './views/Dashboard/index';
import Eventsdetails from './views/Events/eventsDetails';
import Eventsticketbook from './views/Events/eventsBookTicket';
import ScrollToTop from './ScrollToTop';
import Ticketconfirmation from './views/Events/ticketConfirmation';
import Myticket from './views/MyTicket';
import SellTicketDetails from './views/MyTicket/sellTicketDetails';
import Sellticketconfirmation from './views/MyTicket/sellticketConfirmation';
import ResellMKT from './views/ResellMKT';
import Eventresellticketlist from './views/ResellMKT/eventsResellticketlist';
import Eventresellticketbooking from './views/ResellMKT/eventsResellticketbooking';
import Eventresellticketconfirmation from './views/ResellMKT/eventsResellticketconfirmation';
import Myresellticketlist from './views/ResellMKT/myResellticketlist';
import Profile from './views/Pages/profile';
import Changepassword from './views/Pages/channgePassword';
import Aboutus from './views/Pages/aboutus';
import Privacypolicy from './views/Pages/privacypolicy';
import Termscondition from './views/Pages/termsCondition';
import VerifyUser from './views/Signup/VerifyUser';
import ChangeEmail from './views/Signup/ChangeEmail';
import ChangePhone from './views/Signup/ChangePhone';
import VerifyPhone from './views/Signup/VerifyPhone';
import AddPhoneAadhar from './views/Signup/AddPhoneAadhar';

import MyWallet from './views/MyWallet/index';
import Tokendetails from './views/MyWallet/ticketDetails';
import ShareableTicketDetails from './views/MyTicket/ShareableTicketDetails';
// import ForgotPassword from './views/ForgotPW/ForgotPassword';
import VerifyOtp from './views/ForgotPW/VerifyOtp';
import ResetPassword from './views/ForgotPW/ResetPassword';
import Ticketdetails from './views/MyWallet/ticketDetails';
import Page from './views/Pages/Page';


const SignUp = lazy(() => import('./views/Signup/Signup'));
const SocialLogin = lazy(() => import('./views/Login/SocialLogin'));

const ForgotPassword = lazy(() => import('./views/ForgotPW/ForgotPassword'));
const Login = lazy(() => {
    return new Promise(resolve => {
    setTimeout(() => resolve(import('./views/Login/Login')), 500);
  });
});

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
	
    return (
      <Component
        {...props}
        router={{ location, navigate, params }}
      />
    );
  }

  return ComponentWithRouterProp;
}


function App (props) {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallModal, setShowInstallModal] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const refCode = urlParams.get("ref");
    if (refCode) {
      localStorage.setItem("referralCode", refCode);
    }
    checkAutoLogin(dispatch, navigate, location);

    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setDeferredPrompt(event);
      setShowInstallModal(true);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  useEffect(() => {
    // Clear cache on app load
    if ('caches' in window) {
      caches.keys().then(names => {
        names.forEach(name => caches.delete(name));
      });
    }
  }, []);

  const handleInstall = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the install prompt');
        } else {
          console.log('User dismissed the install prompt');
        }
        setDeferredPrompt(null);
        setShowInstallModal(false);
      });
    }
  };

  const handleCancel = () => {
    setShowInstallModal(false);
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();
  // useEffect(() => {
  //    checkAutoLogin(dispatch, navigate);
  // }, []);

  let routeblog = (         
    <Routes>
      <Route path='/' element={<Login />} />
      <Route path='/login' element={<Login />} />
      <Route path='/social-login' element={<SocialLogin />} />
      <Route path='/signup' element={<SignUp />} />
      <Route path='/forgot-password' element={<ForgotPassword />} />
      <Route path='/verify-otp' element={<VerifyOtp />} />
      <Route path='/reset-password' element={<ResetPassword />} />
      <Route path="/verify-user" element={<VerifyUser />} />
      <Route path="/verify-phone" element={<VerifyPhone />} />
      <Route path="/change-email" element={<ChangeEmail />} />
      <Route path="/change-phone" element={<ChangePhone />} />
      <Route path="/add-phoneaadhar" element={<AddPhoneAadhar />} />
      <Route path="/dashboard/events-details/book-ticket/:e_id" element={<Eventsticketbook />} />
      <Route path="/resell-market/ticket-list/:e_id" element={<Eventresellticketlist />} />
      <Route path="/ticket/view" element={<ShareableTicketDetails />} />
      <Route path='*' element={<Login/>} />
    </Routes> 
  );
  if (props.isAuthenticated) {
  return (
    <>
    {showInstallModal && (
        <div className="install-modal" style={{ zIndex:111, position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0, 0, 0, 0.7)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <div style={{ background: 'white', padding: '25px 10px 30px', borderRadius: '10px', textAlign: 'center', width: "100%", maxWidth: "430px", margin: "0 10px" }}>
            <p style={{ fontSize: "20px", marginTop: "8px"}}>Do you want to save this app to your desktop?</p>
            <button onClick={handleInstall} style={{ background: "#6638A2", border: "none", padding:"4px 25px", fontSize: "18px", color: "#fff", borderRadius: "5px", cursor: "pointer"}}>Save</button>
            <button onClick={handleCancel} style={{ marginLeft: '10px', background: "#EFEFEF", border: "none", padding:"4px 25px", fontSize: "18px", borderRadius: "5px", cursor: "pointer" }}>Cancel</button>
          </div>
        </div>
      )}
        <Suspense fallback={
            <div id="preloader">
                <div className="sk-three-bounce">
                    <div className="sk-child sk-bounce1"></div>
                    <div className="sk-child sk-bounce2"></div>
                    <div className="sk-child sk-bounce3"></div>
                </div>
            </div>  
            }
        >
          <Index /> 
        </Suspense>
    </>
);

}else{
  return (
    <div className="vh-100">
      {showInstallModal && (
        <div className="install-modal" style={{ zIndex:111, position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0, 0, 0, 0.7)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <div style={{ background: 'white', padding: '25px 10px 30px', borderRadius: '10px', textAlign: 'center', width: "100%", maxWidth: "430px", margin: "0 10px" }}>
            <p style={{ fontSize: "20px", marginTop: "8px"}}>Do you want to save this app to your desktop?</p>
            <button onClick={handleInstall} style={{ background: "#6638A2", border: "none", padding:"4px 25px", fontSize: "18px", color: "#fff", borderRadius: "5px", cursor: "pointer"}}>Save</button>
            <button onClick={handleCancel} style={{ marginLeft: '10px', background: "#EFEFEF", border: "none", padding:"4px 25px", fontSize: "18px", borderRadius: "5px", cursor: "pointer" }}>Cancel</button>
          </div>
        </div>
      )}
          <Suspense fallback={
              <div id="preloader">
                  <div className="sk-three-bounce">
                      <div className="sk-child sk-bounce1"></div>
                      <div className="sk-child sk-bounce2"></div>
                      <div className="sk-child sk-bounce3"></div>
                  </div>
              </div>
            }
          >
              {routeblog}
          </Suspense>
    </div>
  );
}
};

// function App() {
//   return (
//     <div className="App">
//       <ScrollToTop /> {/* Place this inside the Router */}
//       <Routes>
//         <Route path="/" element={<Login />} />
//         <Route path="/signup" element={<Signup />} />
//         <Route path="/verify-user" element={<VerifyUser />} />

//         <Route path="/forgot-password" element={<ForgotPassword />} />
//         <Route path="/verify-otp" element={<VerifyOtp />} />
//         <Route path="/reset-password" element={<ResetPassword />} />

//         <Route path="/dashboard" element={<Dashboard />} />
//         <Route path="/dashboard/events-details" element={<Eventsdetails />} />
//         <Route path="/dashboard/events-details/book-ticket" element={<Eventsticketbook />} />
//         <Route path="/dashboard/events-details/book-ticket/confirmation" element={<Ticketconfirmation />} />

//         <Route path="/my-tickets" element={<Myticket />} />
//         <Route path="/my-tickets/resell-events-details" element={<Myeventsdetails />} />
//         <Route path="/my-tickets/events-details/confirmation" element={<Sellticketconfirmation />} />

//         <Route path="/resell-market" element={<ResellMKT />} />
//         <Route path="/resell-market/ticket-list" element={<Eventresellticketlist />} />
//         <Route path="/resell-market/ticket-list/book-ticket" element={<Eventresellticketbooking />} />
//         <Route path="/resell-market/ticket-list/book-ticket/confirmation" element={<Eventresellticketconfirmation />} />

//         <Route path="/my-resell-tickets" element={<Myresellticketlist />} />

//         <Route path="/profile" element={<Profile />} />
//         <Route path="/change-password" element={<Changepassword />} />
//         {/* <Route path="/about-us" element={<Aboutus />} /> */}
//         {/* <Route path="/privacy-policy" element={<Privacypolicy />} /> */}
//         {/* <Route path="/terms-conditions" element={<Termscondition />} /> */}
//         <Route path="/:slug" element={<Page />} />

//         <Route path="/my-wallet" element={<MyWallet />} />
//         <Route path="/my-wallet/ticket-details" element={<Ticketdetails />} />

//       </Routes>
//     </div>
//   );
// }

// export default App;

const mapStateToProps = (state) => {
  return {
      isAuthenticated: isAuthenticated(state),
  };
}; 

export default withRouter(connect(mapStateToProps)(App));